module.exports = __webpack_public_path__ + "static/WEDDING E&M-378-4b3a40d05d13c3fd848c0aaddc051e61.jpg";